export default class CreateShippingOrderJob {
    shippingOrderId: number;
    jobTemplateId: number;
}
